export const splitDateRange = (fieldValue: string | undefined) => {
  const splitDate = (fieldValue || ",").split(",");
  const startDate = splitDate[0] || "";
  const endDate = splitDate[1] || "";

  return { startDate, endDate };
};
